export default "__VITE_ASSET__PK$L3nq0__"